import { ISICountryWiseEntity } from './../isi-report-detail/isi-report-detail.model';
import { Input } from '@angular/core/src/metadata/directives';
import { ConstantsService } from './../../services/constants-service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'country-wise-entity',
  templateUrl: './country-wise-entity.component.html',
  styleUrls: ['./country-wise-entity.component.css']
})
export class CountryWiseEntityComponent {

  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;
  @Input()
  reportData: ISICountryWiseEntity;
  @Input()
  listName: string;

  constructor() { }

  toggleList(reportData: ISICountryWiseEntity) {
    this.reportData.open = !reportData.open;
  }



}



// WEBPACK FOOTER //
// ./src/app/reports/country-wise-entity/country-wise-entity.component.ts